 const Fonts={
    lusitanaRegular:".lusitana-regular",
}
export default Fonts;